<template>
  <div class="container mt-2">
    <CRow>
      <CCol md="12" lg="8" xl="8" sm="12">
        <CCard>
          <CCardHeader>🎟️ Registro de Tickets - <b>Sorteo del setup soñado</b></CCardHeader>
          <CCardBody>
            <!-- Datos personales -->
            <CRow class="mb-0">
              <CCol sm="5">
                <CInput
                  v-model="form.dni"
                  maxlength="9"
                  placeholder="Ej. 87654321"
                  label="DNI/CE"
                  @keyup.enter="buscarPersona"
                  v-on:keypress="isNumber($event)"
                  :disabled="esMenor"
                />
                <small class="text-muted d-block">
                  Presiona enter o click en el botón para buscarte
                </small>
              </CCol>

              <CCol sm="1" class="w-100">
                <label>&nbsp;</label>
                <CButton
                  color="primary"
                  @click="buscarPersona"
                  style="border-left: none"
                  :disabled="esMenor"
                >
                  🔍
                </CButton>
              </CCol>

              <CCol sm="1" class="d-flex align-items-center mt-4">
                <input
                  type="checkbox"
                  v-model="esMenor"
                  @change="toggleMenor"
                  class="form-check-input me-1"
                  id="menorCheck"
                />
                <label for="menorCheck" class="form-check-label">Menor</label>
              </CCol>

              <CCol sm="5">
                <CInput
                  :disabled="!esMenor && inputDisabled"
                  v-model="form.nombres"
                  placeholder="Ej. Juan Pérez"
                  label="Nombres Completos"
                />
              </CCol>
            </CRow>

            <!-- Cantidad de tickets y total -->
            <CRow class="mb-3">
              <CCol sm="3">
                <div class="form-group">
                  <label class="">Celular referencial</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model.number="form.phone"
                    placeholder="Ej. 998765432"
                    maxlength="9"
                    v-on:keypress="isNumber($event)"
                  />
                </div>
              </CCol>
              <CCol sm="3">
                <CInput
                  type="text"
                  min="1"
                  max="9"
                  v-model.number="cantidadTickets"
                  @input="generarInputs"
                  placeholder="Ej. 3"
                  label="Número de Tickets"
                />
              </CCol>
              <CCol sm="3">
                <CInput
                  type="text"
                  value="S/ 10"
                  label="Costo del Ticket"
                  disabled
                />
              </CCol>
              <CCol sm="3">
                <CInput label="Total a Pagar" :value="`S/ ${total}`" readonly />
              </CCol>
            </CRow>

            <!-- Lista de tickets -->
            <CRow>
              <CCol
                sm="3"
                v-for="(ticket, index) in tickets"
                :key="index"
                class="mb-2"
              >
                <div class="form-group">
                  <label class="">Ticket #{{ index + 1 }}</label>
                  <input
                    type="text"
                    v-model="ticket.name"
                    :placeholder="`Número del Ticket #${index + 1}`"
                    @blur="consultarNumero(index)"
                    :class="mtdReturnClass(ticket.state)"
                    v-on:keypress="isNumber($event)"
                  />
                  <small class="text-muted d-block" v-if="ticket.name != ''">
                    {{ ticket.state == 1 ? "Ticket libre" : "Ticket reservado" }}
                  </small>
                </div>
              </CCol>
            </CRow>
            <hr />

            <!-- QR de pago -->
            <CRow v-if="total > 0" class="text-center mt-4">
              <CCol sm="6">
                <p class="mt-2">Monto: <strong>S/ {{ total }}</strong></p>
                <p>Al número: <strong>{{ celularYape }}</strong></p>
              </CCol>
              <CCol>
                <p><strong>Escanea para pagar con Yape:</strong></p>
                <img
                  src="https://sorteos.devmiguelrevilla.com/assets/img/yape-img.jpeg"
                  alt="QR Yape"
                />
              </CCol>
            </CRow>

            <!-- Botones -->
            <CRow class="mt-4">
              <CCol sm="12" md="2" lg="2" xl="2"></CCol>
              <CCol sm="12" md="4" lg="4" xl="4">
                <button
                  class="btn btn-success w-100"
                  :disabled="cpButton"
                  @click="mtdSendTicket"
                >
                  <i class="fas fa-check"></i> Reservar Tickets
                </button>
              </CCol>
              <CCol sm="12" md="4" lg="4" xl="4">
                <button
                  class="btn btn-danger w-100"
                  @click="mtdCancelar"
                  :disabled="tickets.length === 0"
                >
                  <i class="fas fa-times"></i> Cancelar
                </button>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="12" lg="4" xl="4" sm="12">
        <div class="mb-3">
          <MediaCarousel />
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import QRCode from "qrcode";
import MediaCarousel from "../components/MediaCarousel.vue";
import { mapActions } from "vuex";

export default {
  name: "RegistroSorteo",
  components: { MediaCarousel },
  data() {
    return {
      form: {
        dni: "",
        nombres: "",
        phone: "",
      },
      inputDisabled: true,
      esMenor: false, // NUEVO
      cantidadTickets: 0,
      tickets: [],
      total: 0,
      qrDataUrl: "",
      celularYape: "904337329",
    };
  },
  computed: {
    cpButton() {
      return !(
        this.form.nombres !== "" &&
        this.form.phone !== "" &&
        this.cantidadTickets > 0
      );
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    toggleMenor() {
      if (this.esMenor) {
        this.form.dni = "";
        this.inputDisabled = false;
      } else {
        this.form.nombres = "";
        this.inputDisabled = true;
      }
    },
    buscarPersona() {
      if (this.esMenor) return;

      if (this.form.dni.length === 8 || this.form.dni.length === 9) {
        const url = this.form.dni.length === 8 ? "/sorteo/" : "/sorteo/cee/";
        this.get({
          url: this.$store.getters.get__url + url + this.form.dni,
        })
          .then((response) => {
            this.form.nombres = response.name + " " + response.last_name;
            this.inputDisabled = true;
            this.$swal({
              toast: true,
              position: "center",
              showConfirmButton: false,
              timer: 3000,
              icon: "success",
              title: "Te hemos encontrado!",
              text: "Puedes continuar",
            });
          })
          .catch(() => {
            this.inputDisabled = false;
            this.$swal({
              toast: true,
              position: "center",
              showConfirmButton: false,
              timer: 3000,
              icon: "warning",
              title: "No te encontramos!",
              text: "Digita tu nombre manualmente",
            });
          });
      }
    },
    generarInputs() {
      if (this.cantidadTickets > 0) {
        this.tickets = Array.from({ length: this.cantidadTickets }, () => ({
          name: "",
          state: 0,
        }));
        this.total = this.cantidadTickets * 10;
      } else {
        this.tickets = [];
        this.total = 0;
      }
    },
    consultarNumero(index) {
      const number = this.tickets[index].name;
      this.get({
        url:
          this.$store.getters.get__url + "/sorteo/consulta/ticket/" + number,
      })
        .then((response) => {
          this.tickets[index].state = response.boo === 1 ? 1 : 0;
          this.$swal({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 3000,
            icon: response.boo === 1 ? "success" : "warning",
            title: "",
            text:
              response.boo === 1
                ? "Puedes continuar"
                : "Escoge otro número",
          });
        })
        .catch(() => {});
    },
    mtdReturnClass(state) {
      return state === 0
        ? "is-invalid form-control"
        : "is-valid form-control";
    },
    mtdCancelar() {
      this.form = { dni: "", nombres: "", phone: "" };
      this.inputDisabled = true;
      this.cantidadTickets = 0;
      this.tickets = [];
      this.total = 0;
      this.esMenor = false;
    },
    mtdValidTickets() {
      return this.tickets.every((t) => t.state === 1);
    },
    mtdSendTicket() {
      if (this.mtdValidTickets()) {
        this.post({
          url: this.$store.getters.get__url + "/sorteo/store/ticket",
          token: this.$store.getters.get__token,
          params: {
            client: this.form,
            cantidadTickets: this.cantidadTickets,
            tickets: this.tickets,
            total: this.total,
          },
        })
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Tickets registrados correctamente!!",
              text: "Te enviaremos un Whatsapp confirmando su participación!",
            });
            this.mtdCancelar();
          })
          .catch(() => {});
      } else {
        this.$swal({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 3000,
          icon: "warning",
          title: "ADVERTENCIA",
          text: "Todos los tickets deben estar disponibles.",
        });
      }
    },
    isNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which || evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.mt-4 {
  margin-top: 1.5rem;
}
.text-center {
  text-align: center;
}
img {
  margin: 0 auto;
  display: block;
  max-width: 200px;
}
.form-group {
  margin-bottom: 0rem;
}
.form-control.is-valid {
  border-color: #2eb85c;
}
</style>
